module.exports = __webpack_public_path__ + "assets/img/2.b01c0d74.svg";